/** @jsx jsx */
import { jsx } from 'theme-ui'
import { bool, func, node, string, number } from 'prop-types'
import { Dialog } from '@reach/dialog'
import '@reach/dialog/styles.css'

// renders a dialog and it's page overlay
const Modal = ({
  children,
  handleDismiss,
  isOpen,
  label,
  maxWidth,
  ...props
}) => {
  // const Modal = ({ children, handleDismiss, isOpen, label, ...props }) => {
  return (
    <Dialog
      aria-label={`${label}`}
      isOpen={isOpen}
      onDismiss={handleDismiss}
      sx={{
        width: ['100%', '80%'],
        maxWidth: maxWidth || 710,
      }}
      {...props}
    >
      {children}
    </Dialog>
  )
}

Modal.propTypes = {
  // content of the dialog
  children: node.isRequired,
  // handles user dismissing the dialog by pressing escape or clicking off the modal (close button in the child is handled separately)
  handleDismiss: func.isRequired,
  // show/hide the dialog
  isOpen: bool.isRequired,
  // sets the aria-label of the dialog for accessibility and testing
  label: string.isRequired,
  maxWidth: number,
}

export default Modal
